import queryString from 'query-string';

import AudienceIdValue from './AudienceIdValue';

/**
 * DDDのfactory
 * このモジュールに必要な全てのクラスの生成を担当
 */
class Factory {
  /**
   * モジュールを作成
   *
   * @returns {Object}
   */
  static create() {
    const parsed = queryString.parse(window.location.search);
    // console.log(parsed);
    // alert(JSON.stringify(parsed));

    const audIdValue = new AudienceIdValue(parsed);
    // console.log(audIdValue);
    // console.log(audIdValue.aud_id);
    // alert(audIdValue.aud_id);

    return {
      "aud_id" : audIdValue.aud_id,
    };
  }
};

export default Factory;
